import RandomQuote from '../components/quotes';

const Quote = () => (
  <>
    <RandomQuote />
  </>
);

export default Quote;
